import { useDisclosure } from '@mantine/hooks';
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

export type TGeoFilterModalContext = 'create' | 'edit';

interface IUseModals {
  editCreate: {
    context: TGeoFilterModalContext;
    setContext: Dispatch<SetStateAction<TGeoFilterModalContext>>;
    isOpen: boolean;
    open: () => void;
    close: () => void;
    handleOpen: (context: TGeoFilterModalContext) => () => void;
  };
  defaultGeoSet: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
  saveCustomSet: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
  saveChanges: {
    isOpen: boolean;
    open: () => void;
    close: () => void;
  };
}

export function useModals(): Readonly<IUseModals> {
  const [editCreateGeoSetModalContext, setEditCreateGeoSetModalContext] =
    useState<TGeoFilterModalContext>('create');
  const [
    isEditCreateGeoSetModalOpen,
    { open: openEditCreateGeoSetModal, close: closeEditCreateGeoSetModal },
  ] = useDisclosure(false);
  const [
    isDefaultGeoSetModalOpen,
    { open: openDefaultGeoSetModal, close: closeDefaultGeoSetModal },
  ] = useDisclosure(false);
  const [
    isSaveCustomSetModalOpen,
    { open: openSaveCustomSetModal, close: closeSaveCustomSetModal },
  ] = useDisclosure(false);
  const [isSaveChangesModalOpen, { open: openSaveChangesModal, close: closeSaveChangesModal }] =
    useDisclosure(false);

  function handleOpenCreateEditGeoSetModal(context: TGeoFilterModalContext): () => void {
    return () => {
      setEditCreateGeoSetModalContext(context);
      openEditCreateGeoSetModal();
    };
  }

  return {
    editCreate: {
      context: editCreateGeoSetModalContext,
      setContext: setEditCreateGeoSetModalContext,
      isOpen: isEditCreateGeoSetModalOpen,
      open: openEditCreateGeoSetModal,
      close: closeEditCreateGeoSetModal,
      handleOpen: handleOpenCreateEditGeoSetModal,
    },
    defaultGeoSet: {
      isOpen: isDefaultGeoSetModalOpen,
      open: openDefaultGeoSetModal,
      close: closeDefaultGeoSetModal,
    },
    saveCustomSet: {
      isOpen: isSaveCustomSetModalOpen,
      open: openSaveCustomSetModal,
      close: closeSaveCustomSetModal,
    },
    saveChanges: {
      isOpen: isSaveChangesModalOpen,
      open: openSaveChangesModal,
      close: closeSaveChangesModal,
    },
  };
}
